import $ from "jquery";
import 'intersection-observer';
import lozad from 'lozad';
import { currentNav } from './_current-nav.js';
import { bgAnime } from './_bg-animation.js';
import { textAnime } from './_text-animation.js';
import { worksList } from './_works-list.js';
import { slide } from './_slide.js';

export const page = {
  next: '',
  isFirst: true,
  backFlg: false,
  scrollY: 0,
  init: ()=>{
    page.checkURL();
    page.nav();
    //ブラウザバック
    window.addEventListener('popstate', function(e){
      page.backFlg = true;
      document.getElementById('wrap').classList.add('disable');
      page.next = location.pathname;
      page.checkURL();
    });
  },
  checkURL: ()=>{
    let url 	= location.href,
        prop 	= location.pathname,
        arry 	= prop.split("/");
    console.log("checkURL: ", url, arry);
    page.beforeChangePage();
    //ここでURLを取得して解析
    if( page.isFirst ){ //ページの訪問時にはページ特有関数を呼ぶだけ
      page.afterChangePage();
      page.isFirst = false;
    }else{ //ページをロードする
      page.loadPage();
    }
  },
  changeURL: ()=>{
    window.history.pushState(null, null, page.next); //URLの書き換え
    document.getElementById('wrap').classList.add('disable'); //ページを一旦非表示にする等のアニメーション
    page.checkURL(); //URLが変わったのでチェック
  },
  nav: ()=>{
    $("a.pushstate").off().on("click", function(e){
      e.preventDefault();
      page.next = $(this).attr("href");
      page.changeURL();
    });
    $("a.pageback").off().on("click", function(e){
      e.preventDefault();
      page.backFlg = true;
      page.next = $(this).attr("href");
      page.changeURL();
    });
  },
  loadPage: ()=>{
    $.get(page.next, {}, function(data){
      let loadedContent = $(data),
          ttl 			    = loadedContent.filter("title")[0].innerHTML,//ページタイトル
          $content 		  = $("#wrap"),//書き換えるDOM
          content 		  = loadedContent.find('#main').prop("outerHTML");//ロードしたコンテンツの中身
      $content.html(content);//ロードしたコンテンツをappend
      document.title = ttl;//ページタイトルを書き換え
      //コンテンツを入れ替えたので、あとはページの表示・関数の呼び出し
      page.afterChangePage();
    });
  },
  beforeChangePage: ()=>{
    if(document.getElementById('main').classList.contains('scrollPos')){
      page.scrollY = window.pageYOffset;
    }
  },
  afterChangePage: ()=>{
    //ページ変更後に呼び出される関数

    //画像遅延読み込み
    const observer = lozad();
    observer.observe();

    //pushStateのリンク先
    page.nav();

    currentNav.init();

    //頂点移動アニメーションのタイマー削除
    //clearInterval(bgAnime.timer);

    //頂点移動
    bgAnime.set();

    //頂点移動インターバルアニメーションを再設定
    /*
    bgAnime.timer = setInterval(()=>{
      bgAnime.set();
    }, bgAnime.interval);
    */

    clearInterval(bgAnime.colorTimer);
    bgAnime.colorSet();
    bgAnime.colorTimer = setInterval(()=>{
      bgAnime.colorSet();
    }, bgAnime.interval);

    document.getElementById('wrap').classList.remove('disable');
    //wrapのdisable解除後
    setTimeout(()=>{
      textAnime.init();
      worksList.init();
      slide.init();
    }, 400);

    //スクロール位置リセット
    if(page.backFlg && document.getElementById('main').classList.contains('scrollPos')){
      window.scrollTo(0, page.scrollY);
      page.backFlg = false;
    }else{
      window.scrollTo(0,0);
    }

  }
}
